export default __webpack_public_path__ + "static/media/bernygroup2a.03c0f2c7.jpg";